import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { SelectItem } from '@psei/ng/api';
import { find } from 'lodash';
import { Subscription } from 'rxjs';
import { PhonePrefix } from '../models/phone-prefix.model';
import { CustomValidators } from '../services/form/custom-validators';
import { PhonePrefixesService } from '../services/phone-prefixes.service';

@Component({
  selector: 'pseic-phone',
  templateUrl: './pseic-phone.component.html',
  styleUrls: ['./pseic-phone.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PseicPhoneComponent implements OnInit, OnDestroy {
  @Input() readonly = false;
  @Input() searchbar = true;
  @Input() singleSelect = true;
  @Input() phoneForm: UntypedFormGroup;

  phonePrefixes: SelectItem[];
  initialPhonePrefixes: PhonePrefix[];

  private subs = new Subscription();

  constructor(private phonePrefixesService: PhonePrefixesService) {
    this.initialPhonePrefixes = this.phonePrefixesService.prefixes;
    this.phonePrefixes = this.initialPhonePrefixes.map(x => {
      const prefix = x.prefix.replace(/\+/g, '');
      return {
        id: x.prefix,
        value: x.prefix,
        label: `${prefix}  (${x.country.toUpperCase()})`,
      }
    });
  }

  ngOnInit(): void {
    if (!this.phoneForm) {
      throw new Error('PseiPhoneComponent - phoneForm not provided  ');
    }
    if (!this.readonly) {
      if (!this.phoneForm.get('prefix').value && !this.phoneForm.get('number').value) {
        this.phoneForm.get('prefix').setValue('+48', { emitEvent: false});
      }
      this.setupChangeListeners();
    } else {
      this.phoneForm.get('number').clearValidators();
      this.phoneForm.get('prefix').clearValidators();
    }
  }

  setupChangeListeners(): void {
    this.subs.add(
      this.phoneForm.get('prefix').valueChanges
        .subscribe((value: string) => {
            const prefixOptions = find(this.initialPhonePrefixes, { prefix: value });
            this.phoneForm.get('number')
              .setValidators([
                CustomValidators.phone(null, null,
                  prefixOptions?.phoneNumberLengthMin,
                  prefixOptions?.phoneNumberLengthMax),
                Validators.required
              ]);
            this.phoneForm.get('number').updateValueAndValidity();
          }
        ));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
